(() => {
  if (customElements.get('amari-delivery-timeframe')) return;

  class AmariDeliveryTimeframe extends HTMLElement {
    static timing(now) {
      const parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Africa/Lagos',
        year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23'
      }).formatToParts(now);
      const values = Object.fromEntries(parts.map(part => [part.type, part.value]));
      const afterCutoff = Number(values.hour) >= 22;
      const delivery = new Date(Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day) + (afterCutoff ? 2 : 1), 12));
      return {
        afterCutoff,
        date: new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Africa/Lagos', weekday: 'long', day: 'numeric', month: 'long'
        }).format(delivery)
      };
    }

    connectedCallback() {
      this.copy = JSON.parse(this.querySelector('[data-delivery-copy]').textContent);
      this.select = this.querySelector('select');
      this.message = this.querySelector('.am-delivery__message');
      this.note = this.querySelector('.am-delivery__note');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.select.addEventListener('change', () => this.render(), options);
      this.querySelector('.am-delivery__controls').hidden = false;
      const scope = this.closest('.shopify-section') || document;
      scope.addEventListener('variant:selected', () => {
        this.dataset.eligible = 'false';
        this.dataset.available = 'true';
        this.render();
      }, options);
      scope.addEventListener('variant:update', event => {
        if (String(event.detail?.data?.productId) !== this.dataset.productId) return;
        const refreshed = event.detail?.data?.html?.getElementById(this.id);
        this.dataset.eligible = refreshed?.dataset.eligible || 'false';
        this.dataset.available = refreshed?.dataset.available || 'false';
        this.render();
      }, options);
      document.addEventListener('visibilitychange', () => this.render(), options);
      window.addEventListener('pageshow', () => this.render(), options);
      this.render();
      this.timer = setInterval(() => this.render(), 1000);
    }

    disconnectedCallback() {
      this.controller?.abort();
      clearInterval(this.timer);
    }

    render() {
      let now = new Date();
      const previewClock = new URLSearchParams(window.location.search).get('amari_delivery_test_at');
      if (this.dataset.preview === 'true' && previewClock && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(Z|\+01:00)$/.test(previewClock)) {
        const testDate = new Date(previewClock);
        if (!Number.isNaN(testDate.getTime())) {
          now = testDate;
          const indicator = this.querySelector('.am-delivery__preview');
          indicator.hidden = false;
          indicator.textContent = 'Preview clock: ' + previewClock;
        }
      }
      let message = this.copy.neutral;
      let note = this.copy.default_note;
      if (this.dataset.available !== 'true') {
        message = this.copy.unavailable;
      } else if (this.select.value === 'lagos') {
        message = this.copy.lagos_neutral;
        if (this.dataset.eligible === 'true') {
          const timing = AmariDeliveryTimeframe.timing(now);
          message = this.copy[timing.afterCutoff ? 'after' : 'before'].replace('__DATE__', timing.date);
          note = this.copy.lagos_note;
        }
      } else if (this.select.value === 'nigeria') {
        message = this.copy.outside;
      } else if (this.select.value === 'other') {
        message = this.copy.other;
      }
      if (this.message.textContent !== message) this.message.textContent = message;
      if (this.note.textContent !== note) this.note.textContent = note;
    }
  }

  customElements.define('amari-delivery-timeframe', AmariDeliveryTimeframe);
})();
